export default __webpack_public_path__ + "static/media/042-pizza cutter.80d2c448.svg";